module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"WidgetSettingsScenarios":{"title":"Настройка сценариев","buttonAdd":"Добавить сценарий","messageListIsEmpty":"Список сценариев пуст..."}},"en_us":{"WidgetSettingsScenarios":{"title":"Setting up scenarios","buttonAdd":"Add scenario","messageListIsEmpty":"Scenarios list is empty ..."}}}')
  delete Component.options._Ctor
}
